import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c76c0b6e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "function-module"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/psychology-app/function-module-description.png"
}, null, -1));
const _hoisted_3 = {
  class: "function-module-swiper-item"
};
const _hoisted_4 = ["src"];
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination } from "swiper/modules";
// import required modules
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
export default /*#__PURE__*/_defineComponent({
  __name: 'function-module',
  setup(__props) {
    const modules = [Pagination];
    const moduleList = ["https://img2.qiuwenxinli.com/official-website/psychology-app/function-module-1.jpg", "https://img2.qiuwenxinli.com/official-website/psychology-app/function-module-2.jpg", "https://img2.qiuwenxinli.com/official-website/psychology-app/function-module-3.jpg", "https://img2.qiuwenxinli.com/official-website/psychology-app/function-module-4.jpg", "https://img2.qiuwenxinli.com/official-website/psychology-app/function-module-5.jpg", "https://img2.qiuwenxinli.com/official-website/psychology-app/function-module-6.jpg"];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_unref(Swiper), {
        style: {
          '--swiper-theme-color': '#FFC56E'
        },
        modules: modules,
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        pagination: {
          clickable: true
        },
        class: "function-module-swiper"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(moduleList, (item, index) => {
          return _createVNode(_unref(SwiperSlide), {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
              class: "function-module-swiper-item-img",
              src: item
            }, null, 8, _hoisted_4)])]),
            _: 2
          }, 1024);
        }), 64))]),
        _: 1
      })]);
    };
  }
});